import Cookies from 'js-cookie'
import { EXPIRE_DATE_TOKEN_NAME, LOCALSTORAGE_TOKEN_NAME, generateSSOpathLogout } from 'modules/auth/auth.constants'
import { clearCookies } from 'modules/auth/auth.service'
import { trace } from 'utils/trace'

function theTokenIsValid() {
  const THE_EXPIRE_DATE_TOKEN = Cookies.get(EXPIRE_DATE_TOKEN_NAME)?.split('|')[0]

  return new Date(Number(THE_EXPIRE_DATE_TOKEN) * 1000) > new Date()
}

// equals to 2 seconds
export const TIMER = 2000
export function action() {
  const THE_EXPIRE_DATE_TOKEN = Cookies.get(EXPIRE_DATE_TOKEN_NAME)?.split('|')[0]

  if (THE_EXPIRE_DATE_TOKEN && !theTokenIsValid()) {
    clearCookies()
    trace.trhowMsg('[trace][3]')
    localStorage.removeItem(LOCALSTORAGE_TOKEN_NAME)
    window.location.href = generateSSOpathLogout()
  }
}

setInterval(action, TIMER)
